import { render, staticRenderFns } from "./ZCzaozhuangbankguquanzhuanrang.vue?vue&type=template&id=02bec90e&scoped=true"
import script from "./ZCzaozhuangbankguquanzhuanrang.vue?vue&type=script&lang=js"
export * from "./ZCzaozhuangbankguquanzhuanrang.vue?vue&type=script&lang=js"
import style0 from "./ZCzaozhuangbankguquanzhuanrang.vue?vue&type=style&index=0&id=02bec90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bec90e",
  null
  
)

export default component.exports